import React, { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface IHeroSection {
  image: string;
  title: string;
  subtitle: string;
  variant?: 'large' | 'small'; // 'large' is default, 'small' uses shorter height and center positioning
  backgroundPosition?: string;
}

export const HeroSection: FC<IHeroSection> = ({
  image,
  title,
  subtitle,
  variant = 'large',
  backgroundPosition
}) => {
  const theme = useTheme();
  const isSmall = variant === 'small';

  const getBackgroundPosition = (): string => {
    if (backgroundPosition) return backgroundPosition;
    if (isSmall) return 'center';
    return '0 25%';
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: { xs: '300px', md: isSmall ? '275px' : '450px' },
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: getBackgroundPosition(),
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'flex-end',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.3)', // Lighten image
          zIndex: 1
        }
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          color: theme.palette.primary.dark,
          px: { xs: 2, md: 4 },
          width: '100%',
          mb: { xs: 0, md: -2 }
        }}
      >
        <Box sx={{ maxWidth: { xs: '100%' } }}>
          <Typography
            variant="h1"
            sx={{
              color: theme.palette.primary.dark,
              lineHeight: 1.25
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              mb: 4,
              color: theme.palette.primary.dark,
              fontStyle: 'italic'
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
